import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { addGlobalEventProcessor, getCurrentHub } from '@sentry/hub';
import { logger } from '@sentry/utils';
var installedIntegrations = [];
/** Map of integrations assigned to a client */

/**
 * @private
 */

function filterDuplicates(integrations) {
  return integrations.reduce(function (acc, integrations) {
    if (acc.every(function (accIntegration) {
      return integrations.name !== accIntegration.name;
    })) {
      acc.push(integrations);
    }

    return acc;
  }, []);
}
/** Gets integration to install */


function getIntegrationsToSetup(options) {
  var defaultIntegrations = options.defaultIntegrations && _toConsumableArray(options.defaultIntegrations) || [];
  var userIntegrations = options.integrations;

  var integrations = _toConsumableArray(filterDuplicates(defaultIntegrations));

  if (Array.isArray(userIntegrations)) {
    // Filter out integrations that are also included in user options
    integrations = [].concat(_toConsumableArray(integrations.filter(function (integrations) {
      return userIntegrations.every(function (userIntegration) {
        return userIntegration.name !== integrations.name;
      });
    })), _toConsumableArray(filterDuplicates(userIntegrations)));
  } else if (typeof userIntegrations === 'function') {
    integrations = userIntegrations(integrations);
    integrations = Array.isArray(integrations) ? integrations : [integrations];
  } // Make sure that if present, `Debug` integration will always run last


  var integrationsNames = integrations.map(function (i) {
    return i.name;
  });
  var alwaysLastToRun = 'Debug';

  if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
    var _integrations;

    (_integrations = integrations).push.apply(_integrations, _toConsumableArray(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
  }

  return integrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */


function setupIntegrations(integrations) {
  var integrationIndex = {};
  integrations.forEach(function (integration) {
    integrationIndex[integration.name] = integration;

    if (installedIntegrations.indexOf(integration.name) === -1) {
      integration.setupOnce(addGlobalEventProcessor, getCurrentHub);
      installedIntegrations.push(integration.name);
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log("Integration installed: ".concat(integration.name));
    }
  });
  return integrationIndex;
}

export { getIntegrationsToSetup, installedIntegrations, setupIntegrations };